import * as React from 'react';

import { observer } from 'mobx-react';

import { Field, FormInput } from '@estee/elc-form';

import { textInputFieldClasses } from '~utils/Classes';
import { FieldValidations } from '~utils/FieldValidations';

export interface ITextInputProps {
    name: string;
    maxLength: number;
    disabled: boolean;
    readonly?: boolean;
    inputType: string;
    afterChange?(fieldName: string, value: string | number): void;
    inputLabel: string;
    fieldValidations: FieldValidations;
}

@observer
export class TextInput extends React.Component<ITextInputProps> {
    public render() {
        const {
            name,
            inputType,
            inputLabel,
            disabled,
            readonly,
            afterChange,
            fieldValidations,
            ...restProps
        } = this.props;
        const { isRequired, maxLength, validations } = fieldValidations || {};

        return (
            <Field
                {...restProps}
                name={name}
                inputType={inputType}
                inputLabel={inputLabel}
                customClassName={textInputFieldClasses(name)}
                isRequired={isRequired}
                disabled={disabled}
                readOnly={readonly}
                maxLength={maxLength}
                dataTestId={`form_${name}`}
                component={FormInput}
                afterChange={afterChange}
                showPasswordLabel={`form_${name}`}
                showPasswordDataTestId={`form_reveal_${name}`}
                validations={validations}
            />
        );
    }
}
